import { render, staticRenderFns } from "./SingpassCallback.vue?vue&type=template&id=152b2fee&"
import script from "./SingpassCallback.vue?vue&type=script&lang=js&"
export * from "./SingpassCallback.vue?vue&type=script&lang=js&"
import style0 from "./SingpassCallback.vue?vue&type=style&index=0&id=152b2fee&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports